// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"372":"merch","795":"confidentiality"}[chunkId] + "." + {"372":"ab6e8fd3","795":"996a4238"}[chunkId] + ".js";
};